"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PenCircle: function() {
        return PenCircle;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const PenCircle = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM15.2929 8.70711C15.1311 8.54535 14.8689 8.54535 14.7071 8.70711L9 14.4142V15L9.58579 15L15.2929 9.29289C15.4547 9.13113 15.4547 8.86887 15.2929 8.70711ZM13.2929 7.29289C14.2357 6.35008 15.7643 6.35008 16.7071 7.29289C17.6499 8.2357 17.6499 9.7643 16.7071 10.7071L11 16.4142C10.6249 16.7893 10.1162 17 9.58579 17H8C7.44772 17 7 16.5523 7 16V14.4142C7 13.8838 7.21071 13.3751 7.58579 13L13.2929 7.29289Z",
        fill: "currentColor"
    })
}), "PenCircle");
const _default = PenCircle;
